var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.999 0a1 1 0 011 1v.286a1 1 0 01-1 1h-22a1 1 0 01-1-1V1a1 1 0 011-1zm0 6.857a1 1 0 011 1v.286a1 1 0 01-1 1h-22a1 1 0 01-1-1v-.286a1 1 0 011-1zm-9 6.857a1 1 0 011 1V15a1 1 0 01-1 1h-13a1 1 0 01-1-1v-.286a1 1 0 011-1z","fill":"currentColor"}));
}

Burger.defaultProps = {"viewBox":"0 0 23.999 16"};

module.exports = Burger;

Burger.default = Burger;
